import {
    useAccount,
    useConnect,
    useDisconnect,
    useEnsName,
  } from 'wagmi'
  import { Button, Text} from '@chakra-ui/react'


  
  export default function AccountButton() {
    const { data: account } = useAccount()
    const { data: ensName } = useEnsName({ address: account?.address as string })
    const { connect, connectors } =
      useConnect()
    const { disconnect } = useDisconnect()
  
    if (account) {
      return (
        <Button onClick={() => disconnect()}>
           <Text>
              {ensName ? `${ensName}` : `${account.address?.toString().substring(0,6)}...${account.address?.toString().substring(account.address?.toString().length-4)}`}
            </Text>
        </Button>
      )
    }
  
    return (
      <Button 
      width={'50%'}
      key={connectors[0].id}
      onClick={() => connect(connectors[0])}>
        <Text >Connect</Text>  
      </Button>
    )
  }